import ContainsFiles from "./contains-files.ts";
import ProjectOrganisationStorey from "./project-organisation-storey.ts";
import BaseFileData from "./base-file-data.ts";
import FileType from "@/models/enums/file-type.ts";
import {StoreyTypologyType} from "@/models/types/storey-typology-type.ts";
import FileData2D from "./file-data-2d.ts";

class ProjectOrganisationBuilding extends ContainsFiles {
    id: string;

    name: string;

    index: number;

    storeys: ProjectOrganisationStorey[] = [];

    file3dFrom2d: BaseFileData | undefined;

    constructor(id: string, name: string, index?: number) {
        super();
        this.id = id;
        this.name = name;

        if (index)
            this.index = index;
        else
            this.index = 0;
    }

    public getStorey(storeyId: string) {
        return this.storeys.find(s => s.id === storeyId);
    }

    public setFile3dFrom2d(fileId: string, revision: number, filePath: string, fileMetaObject: string) {
        this.file3dFrom2d = new BaseFileData(fileId, this.getFile3DFrom2dName(), FileType.File3DFrom2D, revision, filePath, fileMetaObject);
    }

    public handeNewBuildingName(newName: string) {
        this.name = newName;
        if (this.file3dFrom2d)
            this.file3dFrom2d.name = this.getFile3DFrom2dName();
    }

    public addStorey(name: string, altimetry: number, storeyType: StoreyTypologyType, index?: number) {
        const id = crypto.randomUUID();
        const newStorey = new ProjectOrganisationStorey(id, name, altimetry, storeyType, index);
        this.storeys.push(newStorey);
        this.storeys.sort((a, b) => b.altimetry - a.altimetry);
        return newStorey;
    }
    
    public addStoreyFile(storeyId: string, file: FileData2D) {
        const storey = this.storeys.find(s => s.id === storeyId);
        if(storey) {
            storey.addFile(file.fileType, file.id, file.name, file.revision, file.relativePath, file.fileMetaObject, file.content);
        }
    }

    public removeStorey(storeyId: string) {
        const idx = this.storeys.findIndex(s => s.id === storeyId);
        if (idx !== -1) {
            this.storeys.splice(idx, 1);
        }
    }

    public findStoreyAndFileFromFileId(fileId: string): { storey: ProjectOrganisationStorey; file: BaseFileData } | undefined {
        return this.storeys.reduce<{ storey: ProjectOrganisationStorey; file: BaseFileData } | undefined>(
            (found, storey) => {
                if (found) return found;

                const file = storey.files2d.find(f => f.id === fileId);
                return file ? { storey, file } : undefined;
            }, undefined);
    }
        
    public getFile3DFrom2dName() {
        return `2D3D-${this.name}.ifc`;
    }
}

export default ProjectOrganisationBuilding;